export default "__VITE_ASSET__e80fb98e__"